import {call, put, select} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetEventsRawCall} from "../../apis/event";
import {GENERIC_ERROR} from '../../constants/ErrorConstants';
import {GET_EVENTS_SUCCESS} from '../../constants/ExtraConstants';
import {EventStoredObject, EventsStoredObjects, MarketCapObject, MoneyLineObject} from "../../@types/response";
import {getMarketCap} from "../../store/selectors/getMarketCap";
import {getEventsMoneyLine} from "../../store/selectors/getEventsMoneyLine";
import {getFixtures} from "../../store/selectors/getFixtures";

function* tryFunction() {
    const events: EventStoredObject[] = yield call(GetEventsRawCall);
    const marketsCap: MarketCapObject = yield select(getMarketCap);
    const moneyLines: MoneyLineObject = yield select(getEventsMoneyLine);
    const fixtures: EventsStoredObjects = yield select(getFixtures);
    const merged = events.map((e: EventStoredObject) => ({...fixtures[e._id], ...e}));
    yield put({
        type: GET_EVENTS_SUCCESS,
        payload: {events: merged, marketsCap, moneyLines}
    });
}

export function* getEventsSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}